import { useSelector } from "react-redux";
import { formSelectors } from "store/selectors";
import { setEffortFormat } from "store/actions/form";


export default function useEffortFormat(defaultEffortFormat) {
    const { effortFormat: effortFormatFromStore } = useSelector(formSelectors.rto);

    const effortFormat = effortFormatFromStore || defaultEffortFormat.toLowerCase() || "percentage";

    return [effortFormat, setEffortFormat];
};